import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  types,
} from 'mobx-state-tree';
import { utils } from 'lib';

import animate from './animate';
import enterAnimate from '../enter-effects/enter-animate';
import createStore from '../../lib/create-store';

const initState = {
  list: {},
};

const ItemModel = types.model('ItemModel', {
  id: '',
  pic: '',
  name: '',
  left: 0,
  top: 0,
});

const GroupModel = types
  .model('GroupModel', {
    id: types.identifier,
    list: types.array(ItemModel),
  })
  .actions((self) => {
    return {};
  });

const CanvasGiftModel = types.model('CanvasGiftModel', {
  count: 0,
  pic: '',
});
const SvgaAnimationModel = types
  .model('SvgaAnimationModel', {
    url: '',
    position: '',
    ready: false,
  })
  .actions((self) => {
    const setReady = () => {
      self.ready = true;
    };
    return {
      setReady,
    };
  });
const VapAnimationModel = types.model('VapAnimationModel', {
  url: '',
  configUrl: '',
  position: '',
  imgUser: '',
  imgAnchor: '',
  textUser: '',
  textAnchor: '',
  text: '',
  fontStyle: '',
});

export const Model = types
  .model('AnimationModel', {
    videoGiftList: types.map(GroupModel),
    canvasGift: types.maybeNull(CanvasGiftModel),
    videoSvgaAnimation: types.maybeNull(SvgaAnimationModel),
    svgaAnimation: types.maybeNull(SvgaAnimationModel),
    videoVapAnimation: types.maybeNull(VapAnimationModel),
    enterAnimation: types.maybeNull(VapAnimationModel),
  })
  .views((self) => {
    return {
      get videoGiftAry() {
        return [...self.videoGiftList];
      },
    };
  })
  .actions((self) => {
    // 视频上方的 礼物图片 随机展示
    const addVideoGift = ({ pic, name, count }) => {
      let list = [];
      let max = count > 50 ? 50 : count;
      // for (let i = 0; i < max; i++) {
      list.push({
        id: utils.getRandomString(),
        name,
        pic,
        left: Math.floor(Math.random() * 480),
        top: Math.floor(Math.random() * 360),
      });
      // }
      let group = {
        id: utils.getRandomString(),
        list,
      };
      self.videoGiftList.put(group);

      // console.log('videoGift list', [...self.videoGiftList])

      setTimeout(() => {
        self.deleteVideoGift(group.id);
      }, 3000);
    };

    const deleteVideoGift = (id) => {
      self.videoGiftList.delete(id);
    };

    const setVideoSvgaAnimation = (url, position) => {
      self.videoSvgaAnimation = {
        url,
        position,
      };
    };
    const clearVideoSvgaAnimation = () => {
      self.videoSvgaAnimation = null;
      animate.next();
    };

    const setVideoVapAnimation = (opt) => {
      self.videoVapAnimation = opt;
    };
    const clearVideoVapAnimation = () => {
      self.videoVapAnimation = null;
      animate.next();
    };

    const setEnterAnimation = (opt) => {
      self.enterAnimation = opt;
    };
    const clearEnterAnimation = () => {
      self.enterAnimation = null;
      enterAnimate.next();
    };

    const setSvgaAnimation = (url) => {
      self.svgaAnimation = {
        url,
      };
    };
    const clearSvgaAnimation = () => {
      self.svgaAnimation = null;
      animate.next();
    };

    const setCanvasGift = (count, pic) => {
      self.canvasGift = {
        count,
        pic,
      };
    };
    const clearCanvasGift = () => {
      self.canvasGift = null;
      animate.next();
    };

    return {
      addVideoGift,
      deleteVideoGift,

      setCanvasGift,
      clearCanvasGift,

      setSvgaAnimation,
      clearSvgaAnimation,

      setVideoSvgaAnimation,
      clearVideoSvgaAnimation,

      setVideoVapAnimation,
      clearVideoVapAnimation,

      setEnterAnimation,
      clearEnterAnimation,
    };
  });

let { store, Provider, useStore } = createStore(Model, initState);

export {
  store,
  Provider,
  useStore,
  // GiftCategoryModel,
  // GiftTabModel
};
